import React from "react";

import { ExecutorTeamIdCellContent as Content } from "../components";

import base from "./base";

import { Column, ColumnId } from ".";

function executorTeamId({ width, onResize }: Column.Options) {
	return base(ColumnId.ExecutorTeamId, (item) => <Content item={item} />, {
		width,

		onResize: onResize as (
			columnWidth?: number | undefined,
			dataKey?: string | undefined,
		) => void,
	});
}

export default executorTeamId;
